/**
 * Filter Cache Utilities
 * 
 * Provides utilities for caching analytics filters by site with timestamp-based expiry.
 * Cache is stored in Redux state and automatically cleared on page refresh.
 */

export const CACHE_EXPIRY_MS = 30 * 60 * 1000; // 30 minutes in milliseconds

/**
 * Check if a cache entry is valid (not expired)
 * @param {Object} cacheEntry - Cache entry with fetchedAt timestamp
 * @param {number} expiryMs - Expiry time in milliseconds (optional, defaults to CACHE_EXPIRY_MS)
 * @returns {boolean} - True if cache is valid, false if expired or invalid
 */
export const isCacheValid = (cacheEntry, expiryMs = CACHE_EXPIRY_MS) => {
  if (!cacheEntry || !cacheEntry.fetchedAt) {
    return false;
  }
  
  const now = Date.now();
  const timeSinceFetch = now - cacheEntry.fetchedAt;
  
  return timeSinceFetch < expiryMs;
};